type Translate = (key: string, values?: Record<string, unknown>) => string;

/**
 * The distance of a recording attached to a comment. Shared by Comment.vue and CommentThread.vue,
 * which each had a copy; under 1 km it printed the raw metres ("842.3718 m").
 */
export function formatCommentRecordingDistance(meters: number | null | undefined, t: Translate): string {
  if (!meters) return t('comments.comment.distance_km', { distance: 0 });
  const rounded = Math.round(meters);
  return rounded < 1000
    ? t('comments.comment.distance_m', { distance: rounded })
    : t('comments.comment.distance_km', { distance: (Math.round(meters / 100) / 10).toFixed(1) });
}
